import { IonLabel } from '@ionic/react';
import { useTranslation } from 'react-i18next';

import { Mission } from '@carers/views/Missions/models/Missions';
import { Request } from '@carers/views/Requests/models/Requests';
import Alert from '@shared/components/Alert/Alert';
import { SERVICES } from '@shared/constants/missionsConstants';

type IsAtHomeMissionAlertProps = {
  mission: Request | Mission;
};

const IsAtHomeMissionAlert = ({ mission }: IsAtHomeMissionAlertProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'carers.requests.detail.alerts.atHomeMission' });

  const isAtHomeMission = mission.service.value === SERVICES.HOME_NURSING_SERVICES;

  if (!isAtHomeMission) {
    return null;
  }

  return (
    <Alert type="warning" title={t('title')}>
      <IonLabel>{t('message')}</IonLabel>
    </Alert>
  );
};

export default IsAtHomeMissionAlert;
